import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Card } from "reactstrap";
import AmazonProductListingFieldRow from "./AmazonProductListingFieldRow";
import FetchAllAssetsAsinWiseService from "../../../../../Service/OPSServices/AmazonProductListing_v1/FetchAllAssetsAsinWiseService";

import AssetsgalleryImges from "./AssetsGalleryImges";
import { connect } from "react-redux";
import CustomModal from "../../../../Components/Modals/CustomModal";
import VariationsChildGrid from "./VariationsChildGrid";

function AmazonProductListingGroupSection(props) {
  const [galleryImg, setGalleryImg] = useState();
  const [imagePopUpOPen, setImagePopUpOPen] = useState(false)
  // const [selectedImagesMap, setSelectedImagesMap] = useState({}); // { fieldName: asset }
  const [slectedImgReplace, setSelectedReplace] = useState([]);
  // const [originalImageMap, setOriginalImageMap] = useState({});
  const [loading, setLoading] = useState(true);
  const selectedImages = useMemo(() => {
    if (!slectedImgReplace || !slectedImgReplace.field) return null;

    // If already set in map, use it directly
    if (props.selectedImagesMap[slectedImgReplace.field]) {
      return props.selectedImagesMap[slectedImgReplace.field];
    }

    if (!galleryImg || !galleryImg.length) return null;

    const extractFilePath = (val) => {
      if (!val) return null;
      if (typeof val === "string") return val;
      const item = Array.isArray(val) ? val[0] : val;
      if (!item) return null;
      if (typeof item === "string") return item;
      if (typeof item === "object") {
        return Object.values(item).find(v => typeof v === "string" && v.startsWith("http")) || null;
      }
      return null;
    };

    const field = slectedImgReplace;
    const alreadyChanged = props.changedFields && props.changedFields[field.field];

    // Check changedFields first
    if (alreadyChanged && alreadyChanged.value) {
      const changedPath = extractFilePath(alreadyChanged.value);
      const matched = galleryImg.find(img => img.filePath === changedPath);
      if (matched) return matched;
    }

    // Fallback to existing field value
    const existingPath = extractFilePath(field.normalized_value)
      || extractFilePath(field.listing && field.listing.value)
      || null;

    return galleryImg.find(img => img.filePath === existingPath) || null;

  }, [slectedImgReplace, props.selectedImagesMap, props.changedFields, galleryImg]);

  const setSelectedImages = (img) => {
    if (!slectedImgReplace || !slectedImgReplace.field) return;
    props.setSelectedImagesMap(prev => ({
      ...prev,
      [slectedImgReplace.field]: img
    }));
  };
  const variationTheme = useMemo(() => {
    const sourceFields = props.allFields || props.fields || [];
    const themeField = sourceFields.find(f => f.field === "variation_theme");

    if (!themeField) return null;

    // Priority 1: normalized_value
    let val = themeField.normalized_value;

    // Priority 2: listing.value (seller-specific)
    if (!val) {
      val = themeField.listing && themeField.listing.value;
    }

    // Priority 3: catalog.value (Array(1) → first element)
    if (!val) {
      val = themeField.catalog && themeField.catalog.value;
    }

    // e.g. [{value: "COLOR"}] → "COLOR"  OR  ["COLOR"] → "COLOR"
    if (Array.isArray(val)) {
      const first = val[0];
      if (first && typeof first === "object" && first.value !== undefined) {
        return first.value || null;   // [{value: "COLOR"}] case
      }
      return first || null;           // ["COLOR"] case
    }

    if (val && typeof val === "object" && val.value !== undefined) {
      return val.value || null;
    }

    return val || null;
  }, [props.allFields, props.fields]);

  useEffect(() => {
    setLoading(true);
    let data = {
      asin: props.selectedAsin

    };
    FetchAllAssetsAsinWiseService(props.token, data).then((res) => {
      if (res) {
        setGalleryImg(res.fileList);
        setLoading(false);

      }
    });
  }, []);

  const handleAction = (value) => {
    setSelectedReplace(value);
    setImagePopUpOPen(true);

    // Save original value for unselect restore
    if (value && value.field) {
      const extractFilePath = (val) => {
        if (!val) return null;
        if (typeof val === "string") return val;
        const item = Array.isArray(val) ? val[0] : val;
        if (!item) return null;
        if (typeof item === "string") return item;
        if (typeof item === "object") {
          return Object.values(item).find(v => typeof v === "string" && v.startsWith("http")) || null;
        }
        return null;
      };

      const existingValue = extractFilePath(value.normalized_value)
        || extractFilePath(value.listing && value.listing.value)
        || null;

      props.setOriginalImageMap(prev => ({
        ...prev,
        [value.field]: existingValue
      }));
    }
  };


  const handleChange = () => {

    if (props.onFieldChange) {

      props.onFieldChange({
        field: slectedImgReplace.field,
        value: selectedImages.filePath
      });
    }

    setImagePopUpOPen(false);
  };
  const handleUnselect = () => {
    if (!slectedImgReplace || !slectedImgReplace.field) return;
    const originalValue = props.originalImageMap[slectedImgReplace.field];

    if (props.onFieldChange) {
      props.onFieldChange({
        field: slectedImgReplace.field,
        value: originalValue || null
      });
    }
  };

  if (!props.fields || props.fields.length === 0) return null;

  const renderGridContent = () => (
    <div className="group-section-body">
      <Row className="g-2 px-3 py-2 border-bottom align-items-center m-0 group-section-col-headers"
        style={{
          position: "sticky",
          top: "285px",
          zIndex: 99,
        }}>
        <Col md={2}>Field</Col>
        <Col md={3}>Catalog</Col>
        <Col md={3}>Listing</Col>
        <Col md={4}>Edit</Col>
      </Row>

      <div className="group-section-scroll-container">
        {props.fields.map((f, i) => (
          <AmazonProductListingFieldRow
            key={f && f.field ? f.field : i}
            field={f}
            action={handleAction}
            onFieldChange={props.onFieldChange}
            changedFields={props.changedFields}
            readOnly={props.title === "Variations"}
            selectedAsin={props.selectedAsin}
            sku={props.sku}
            isParentProduct={props.isParentProduct}
            storeName={props.storeName}
          />
        ))}
      </div>
    </div>
  );

  return (
    <>
      <div className="group-section-container">

        {props.title === "Variations" ? (
          <Card className="card-of-problemarea p-3 mb-4 shadow-sm border-0">
            {renderGridContent()}
          </Card>
        ) : (
          renderGridContent()
        )}

        <div>
          {props.title === "Variations" && props.isParentProduct && (
            <VariationsChildGrid
              token={props.token}
              selectedAsin={props.selectedAsin}
              sku={props.sku}
              prefetchedVariationTheme={variationTheme}
              schemaFields={props.allFields}
              isParentProduct={props.isParentProduct}
            />
          )}
        </div>
      </div>
      <CustomModal
        header={"Select Image"}
        isOpen={imagePopUpOPen}
        toggle={() => {
          setImagePopUpOPen(false);
          if (slectedImgReplace && slectedImgReplace.field) {
            props.setSelectedImagesMap(prev => {
              const updated = { ...prev };
              delete updated[slectedImgReplace.field];
              return updated;
            });
          }
        }}

        size={"xl"}
        className='curve-popup'
      >
        <AssetsgalleryImges
          galleryImg={galleryImg}
          setGalleryImg={setGalleryImg}
          selectedImages={selectedImages}
          setSelectedImages={setSelectedImages}
          handleSubmitFile={handleChange}
          onUnselect={handleUnselect}
          loading={loading}
        />
      </CustomModal>

    </>
  );
}

var mapStateToProps = function (state) {
  return { token: state.loggedUser.token };
};

export default connect(mapStateToProps)(AmazonProductListingGroupSection);